import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'createby', 'nmcategory', 'jasa', 'requestno',  'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal','isproject','approved','pr','statuswf','outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = `/mr${str}`;
                if (obj.viewOption == "Header") {
                    url = `/mr/list${str}`;
                }
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    myrequest(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'createby', 'nmcategory', 'jasa', 'requestno', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal','isproject','approved','pr','statuswf','outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                
                let url = `/mr/byrequestor${str}`;
                if (obj.viewOption == "Header") {
                    url = `/mr/byrequestorheader${str}`;
                }
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    mrReserved(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'jasa', 'requestno', 'requestkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                // console.log("#obj: ", obj);
                let url = `/mr/mrReserved${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const resp = await axios.post('/mr', obj);
                // resolve(resp);
                const { data } = await axios.post("mr", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    reserved(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("mr/reserved", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/mr/${obj.requestkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    closed(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/mr/closed/${obj.reqdtlkey}`,obj);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    actionhistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/mr/actionhistory/${obj.requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/mr/detail/${obj.requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    // actionhistory(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const { data } = await axios.get(`/mr/actionhistory/${obj.requestkey}`);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },

    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'createby', 'nmcategory', 'jasa', 'requestno', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal','approved','pr'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/mr/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'open_requisition_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename);
                const { data } = await axios.post("mr/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/mr/send2wfCancel/${obj.requestkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.requestkey) {
                    const url = `/mr/print?key=${obj.requestkey}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
};